import React from 'react';
import { IconSearchSVG, IconMenuNavSVG } from '../../icon';
import { applyFilters } from '@wordpress/hooks';

const proMenu = ['jkit-single-post', 'jkit-archive-template', 'jkit-popup-template', 'jkit-single-product', 'jkit-header', 'jkit-footer', 'jkit-404'];

const Sidebar = (props) => {
    const userPro = applyFilters('jkit.dashboard.is.pro', false);
    const {
        activeMenu,
        setActiveMenu,
        menus,
        setShowBanner
    } = props;

    const menuChange = (menuSlug) => {
        if (proMenu.includes(menuSlug) && !userPro) {
            setShowBanner(true)
        } else {
            setActiveMenu(menuSlug)
        }
    }

    return <div className="f-theme-sidebar-wrapper">
        <div className="f-menus-wrapper">
            {menus.map((menu, key) => (
                <Menu key={key} activeMenu={activeMenu} setActiveMenu={menuChange} {...menu} setShowBanner={setShowBanner} userPro={userPro} />
            ))}
        </div>
    </div>;
};

const Menu = ({ menu, submenu, setActiveMenu, activeMenu, setShowBanner, userPro }) => {
    return <div className="f-theme-menu-wrapper">
        <div className="f-theme-menu">{menu}</div>
        <div className="f-submenu-wrapper">
            {submenu.map((menu, key) => (
                <MenuItem menu={menu} key={key} setActiveMenu={setActiveMenu} activeMenu={activeMenu} setShowBanner={setShowBanner} userPro={userPro} />
            ))}
        </div>
    </div>;
};

const MenuItem = ({ menu, key, setActiveMenu, activeMenu, userPro }) => {

    return <div className={`f-submenu ${menu.slug === activeMenu ? 'active' : ''}`} key={key} onClick={() => setActiveMenu(menu.slug)}>
        {<div className="f-active"><IconMenuNavSVG /></div>}
        <div className="f-menu-item">
            <i className={`essential-icon ${menu.slug}`}></i>
            <span className='menu-title'>{menu.title}</span>
            {proMenu.includes(menu.slug) && !userPro && <ProMenu />}
        </div>
    </div>
}

const ProMenu = () => {
    return <span className='pro-menu'>
        <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.82025 2.14721C7.74296 2.08158 7.64722 2.0398 7.54527 2.02722C7.44333 2.01464 7.33983 2.03183 7.24803 2.07659L5.73523 2.80721L4.445 0.7294C4.39878 0.655055 4.33351 0.593549 4.25551 0.550852C4.17752 0.508155 4.08946 0.485718 3.99987 0.485718C3.91029 0.485718 3.82223 0.508155 3.74424 0.550852C3.66624 0.593549 3.60097 0.655055 3.55474 0.7294L2.26451 2.80721L0.751397 2.0769C0.659693 2.03252 0.556482 2.01542 0.454767 2.02777C0.353052 2.04011 0.257383 2.08134 0.179813 2.14627C0.102243 2.2112 0.0462413 2.29691 0.0188636 2.39262C-0.00851405 2.48833 -0.00604316 2.58974 0.025965 2.68409L1.21943 6.22628C1.2374 6.27964 1.26751 6.32842 1.30754 6.36901C1.34757 6.40959 1.39649 6.44095 1.4507 6.46078C1.50491 6.4806 1.56302 6.48839 1.62074 6.48355C1.67847 6.47872 1.73434 6.46139 1.78423 6.43284C1.79197 6.42847 2.59256 5.98565 3.99923 5.98565C5.4059 5.98565 6.20649 6.42909 6.21262 6.43253C6.26251 6.46145 6.31849 6.4791 6.37639 6.48419C6.43429 6.48927 6.49263 6.48165 6.54708 6.4619C6.60153 6.44214 6.65068 6.41076 6.69089 6.37008C6.7311 6.3294 6.76134 6.28046 6.77935 6.2269L7.97282 2.68659C8.00576 2.59219 8.00883 2.49041 7.98165 2.3943C7.95446 2.2982 7.89826 2.21215 7.82025 2.14721ZM6.17746 5.59565C5.74685 5.43565 5.00561 5.23565 3.99923 5.23565C2.99285 5.23565 2.25161 5.43628 1.821 5.59628L0.950092 3.01159L2.12839 3.5794C2.2455 3.63539 2.38 3.64684 2.50539 3.6115C2.63078 3.57615 2.73795 3.49658 2.80577 3.38846L3.99923 1.4669L5.19269 3.38878C5.26051 3.49689 5.3677 3.57645 5.49311 3.61174C5.61851 3.64703 5.75301 3.63549 5.87006 3.5794L7.04804 3.01065L6.17746 5.59565Z" fill="white" />
        </svg>
        <span>Pro</span>
    </span>;
}

export default Sidebar;
